/**
 * Helper functions for product images
 * Structure: public/images/products/[productId]/main.png
 */

/** Extra gallery files named gallery-2.png … gallery-N.png (AFOBRICK downloads). */
function galleryExtras(last: number): string[] {
  return Array.from({ length: last - 1 }, (_, i) => `gallery-${i + 2}.png`);
}

const EXTRA_PRODUCT_IMAGES: Record<string, string[]> = {
  "35001": galleryExtras(12),
  "35002": galleryExtras(13),
  "35003": galleryExtras(12),
  "97055": ["gallery-2.png", "gallery-3.png", "gallery-4.png"],
  "91013": ["gallery-2.jpg", "gallery-3.jpg", "gallery-4.jpg"],
  "95022": galleryExtras(9),
  "95027": galleryExtras(7),
  "95028": galleryExtras(9),
  "95023": [
    "950232.png",
    "950233.png",
    "950234.png",
    "950235.png",
    "950236.png",
    "950237.png",
  ],
  "98015": [
    "12GO98015U-BOOTU-96_3_800x.png",
    "12GO98015U-BOOTU-96_6_700x.png",
    "12GO98015U-BOOTU-96_7_700x.png",
    "12GO98015U-BOOTU-96_8_700x.png",
    "12GO98015U-BOOTU-96_10_700x.png",
    "12GO98015U-BOOTU-96_11_700x.png",
  ],
  "98016": [
    "mmexport1790225824378_800x.png",
    "mmexport1790225817630_800x.png",
    "mmexport1790225808702_600x.png",
    "mmexport1790225821031_800x.png",
    "mmexport1790225828644_800x.jpg",
  ],
  "97056": [
    "12GO97056FV215TankDestroyer_2_700x.png",
    "12GO97056FV215TankDestroyer_3_800x.png",
    "12GO97056FV215TankDestroyer_4_800x.png",
    "12GO97056FV215TankDestroyer_5_800x.png",
  ],
  "95020": [
    "12GOF1Series_2_600x.webp",
    "12GOF1Series_3_600x.webp",
    "12GOF1Series_4_600x.webp",
    "12GOF1Series_5_600x.webp",
    "12GOF1Series_6_600x.webp",
  ],
  "95025": [
    "12GOF1Series_7_600x.webp",
    "12GOF1Series_10_600x.jpg",
    "12GOF1Series_11_600x.webp",
    "12GOF1Series_12_600x.webp",
    "12GOF1Series_13_600x.webp",
  ],
  "95026": [
    "12GOF1Series_8_600x.webp",
    "gallery-3.png",
    "gallery-4.png",
    "gallery-5.png",
    "gallery-6.png",
  ],
  "95021": [
    "12GO95021BMWTouringCarGrandPrix_2_600x.png",
    "12GO95021BMWTouringCarGrandPrix_3_600x.png",
    "12GO95021BMWTouringCarGrandPrix_4_600x.png",
    "12GO95021BMWTouringCarGrandPrix_5_600x.png",
  ],
  "97059": [
    "12GO97059PANTHERII_2_800x.png",
    "12GO97059PANTHERII_3_800x.png",
    "12GO97059PANTHERII_4_800x.png",
  ],
  "97027": [
    "12GO_97027_Tiger_II_1.png",
    "12GO_97027_Tiger_II_2.png",
    "12GO_97027_Tiger_II_3.png",
    "12GO_97027_Tiger_II_4.png",
    "12GO_97027_Tiger_II_5.png",
  ],
  "95009": [
    "12GO95009T34-V2TankEngine_2_600x.png",
    "12GO95009T34-V2TankEngine_3_600x.png",
    "12GO95009T34-V2TankEngine_4_600x.png",
    "12GO95009T34-V2TankEngine_5_600x.png",
  ],
  "97036": [
    "mmexport1786162513110_600x.png",
    "mmexport1786162517801_600x.png",
    "mmexport1786162522454_600x.png",
    "mmexport1786162526444_600x.png",
    "mmexport1786162530207_600x.png",
    "mmexport1786162535072_600x.png",
    "mmexport1786162538818_600x.png",
  ],
  "97060": [
    "mmexport1783323477332_600x.png",
    "mmexport1783323480993_600x.png",
    "mmexport1783323484816_600x.png",
    "mmexport1783323473729_600x.png",
  ],
  "97066": [
    "022f4394c51979059a077bfaae0c288d.jpg@.png",
    "03586a2df761e1fe97e5429bdca1e549.jpg@.png",
    "1d0e8e426f2970b86dae42078f0e6709.jpg@.png",
    "271700ead305832700636cdbf9dbff6b.jpg@.png",
    "2af9ca15d2c47d1256ea25026265c697.jpg@.png",
    "4364edfbeb82da836505547c26ef45c6.jpg@.png",
    "49fb43e6fc10e9cae9fb782b95dfd9f5.jpg@.png",
    "50cb58a116bfc595f551b884c52f9c25.jpg@.png",
    "6e2c144bdd1ad2b54caffa7158c49220.jpg@.png",
    "77023b23bfce73f5f177e2fe941035d2.jpg@.png",
    "9873534c074fda2d0d88b8a73e9c012a.jpg@.png",
    "aa1419320ec386bf2a79e497fd5b6b12.jpg@.png",
    "c7e68d9cf1d91e98dd14f5eef4930e37.jpg@.png",
    "cab5eaaacf89073a8a0743f23a33888c.jpg@.png",
    "e2f58fb6347e6dba8df91495bb4430ca.jpg@.png",
  ],
  "97038": [
    "IMG_0520_600x.png",
    "IMG_0521_600x.png",
    "IMG_0522_600x.png",
    "IMG_0524_600x.png",
  ],
  "96001": galleryExtras(8),
  "96002": galleryExtras(7),
  "96003": galleryExtras(8),
  "96005": galleryExtras(8),
  "96006": galleryExtras(9),
  "96007": galleryExtras(9),
  "96008": galleryExtras(11),
  "96009": galleryExtras(6),
  "96010": galleryExtras(6),
  "97001": ["gallery-3.png", "gallery-4.png", "gallery-5.png"],
  "97002": galleryExtras(5),
  "97003": ["gallery-2.png", "gallery-3.png", "gallery-5.png", "gallery-6.png", "gallery-7.png"],
  "97005": galleryExtras(5),
  "97006": galleryExtras(5),
  "97007": galleryExtras(5),
  "97008": galleryExtras(5),
  "97009": galleryExtras(5),
  "97011": galleryExtras(7),
  "97012": galleryExtras(5),
  "97013": galleryExtras(8),
  "97015": galleryExtras(5),
  "98001": galleryExtras(8),
  "98002": galleryExtras(8),
  "98006": galleryExtras(6),
  "95002": galleryExtras(9),
  "95003": galleryExtras(6),
  "95005": galleryExtras(10),
  "95006": galleryExtras(3),
  "95007": galleryExtras(9),
  "95008": galleryExtras(7),
  "95010": galleryExtras(5),
  "96011": galleryExtras(5),
  "96012": galleryExtras(6),
  "97010": galleryExtras(7),
  "97016": galleryExtras(3),
  "97017": ["gallery-2.png", "gallery-3.png", "gallery-4.png", "gallery-7.png"],
  "97018": ["gallery-2.png", "gallery-3.png", "gallery-4.png", "gallery-5.png", "gallery-7.png"],
  "97019": galleryExtras(3),
  "97020": ["gallery-3.png", "gallery-4.png", "gallery-5.png", "gallery-6.png", "gallery-7.png", "gallery-8.png"],
  "97021": ["gallery-2.png", "gallery-3.png", "gallery-4.png", "gallery-5.png", "gallery-7.png"],
  "97022": galleryExtras(3),
  "97023": galleryExtras(9),
  "97025": galleryExtras(6),
  "97026": galleryExtras(7),
  "97029": galleryExtras(3),
  "97030": galleryExtras(2),
  "97031": galleryExtras(2),
  "97032": ["gallery-3.png", "gallery-4.png", "gallery-5.png", "gallery-6.png", "gallery-7.png", "gallery-8.png"],
  "97037": galleryExtras(8),
  "97039": galleryExtras(8),
  "98003": galleryExtras(7),
  "98005": galleryExtras(5),
  "98007": galleryExtras(2),
  "98008": ["gallery-2.png", "gallery-3.png", "gallery-4.png", "gallery-5.png", "gallery-7.png"],
  "98009": galleryExtras(5),
  "98010": ["gallery-2.png", "gallery-3.png", "gallery-4.png", "gallery-5.png", "gallery-6.png", "gallery-8.png"],
  "98013": galleryExtras(8),
};

// Some older products use JPG for their main image.
const MAIN_IMAGE_FORMAT: Partial<Record<string, "jpg" | "png" | "webp">> = {
  "95007": "jpg",
  "91013": "jpg",
  "95020": "webp",
  "95025": "webp",
  "95026": "webp",
};

export function getProductImagePath(
  productId: string,
  format: "jpg" | "png" | "webp" = "png"
): string {
  return `/images/products/${productId}/main.${format}`;
}

export function getProductImageSrc(productId: string): string {
  return getProductImagePath(productId, MAIN_IMAGE_FORMAT[productId] ?? "png");
}

/**
 * Returns the path to the optimized product-card / thumbnail image.
 * This file is generated by `scripts/generate-product-thumbnails.js`.
 */
export function getProductImageThumbSrc(productId: string): string {
  return `/images/products/${productId}/main-thumb.webp`;
}

export function getProductImageAlt(
  productName: string | undefined,
  productNumbering: string
): string {
  return productName ? `${productName} (${productNumbering})` : `12GO ${productNumbering}`;
}

export function getExtraProductImages(productId: string): string[] {
  const files = EXTRA_PRODUCT_IMAGES[productId] ?? [];
  return files.map((file) => `/images/products/${productId}/${file}`);
}

/** Returns list of product image paths (main + extra images). */
export function getProductImageList(productId: string): string[] {
  return [getProductImageSrc(productId), ...getExtraProductImages(productId)];
}

function getThumbSrcForImageUrl(src: string): string {
  // src is a public URL like: /images/products/97009/main.png
  const parts = src.split("/");
  const productId = parts[parts.length - 2];
  const file = parts[parts.length - 1];
  if (!productId || !file) return src;

  if (file === "main-thumb.webp" || file.endsWith("-thumb.webp")) return src;

  if (file.startsWith("main.")) {
    return `/images/products/${productId}/main-thumb.webp`;
  }

  const dot = file.lastIndexOf(".");
  if (dot === -1) return src;
  const base = file.slice(0, dot);
  return `/images/products/${productId}/${base}-thumb.webp`;
}

/** Returns optimized thumbnails for gallery buttons (same ordering as `getProductImageList`). */
export function getProductImageThumbList(productId: string): string[] {
  return getProductImageList(productId).map(getThumbSrcForImageUrl);
}

